// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import OthersNew from '../_raw/service/icon_others_new.svg';
import withIconProps from '../withIconProps';

export default withIconProps(OthersNew);
